'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import * as React from 'react';
import { cn } from '../../utils';
/* eslint-disable react/prop-types */
/**
 * Augments native scroll functionality for custom, cross-browser styling.
 *
 * https://ui.shadcn.com/docs/components/scroll-area
 */
const ScrollAreaRoot = React.forwardRef(({ className, children, ...props }, ref) => (_jsxs(ScrollAreaPrimitive.Root, { ref: ref, className: cn('relative overflow-hidden', className), ...props, children: [_jsx(ScrollAreaPrimitive.Viewport, { className: "h-full w-full rounded-[inherit]", children: children }), _jsx(ScrollBar, {}), _jsx(ScrollAreaPrimitive.Corner, {})] })));
ScrollAreaRoot.displayName = ScrollAreaPrimitive.Root.displayName;
const ScrollBar = React.forwardRef(({ className, orientation = 'vertical', ...props }, ref) => (_jsx(ScrollAreaPrimitive.ScrollAreaScrollbar, { ref: ref, orientation: orientation, className: cn('flex touch-none select-none transition-colors data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out-0 data-[state=visible]:fade-in-0', orientation === 'vertical' &&
        'h-full w-2.5 border-l border-l-transparent p-[1px]', orientation === 'horizontal' &&
        'h-2.5 flex-col border-t border-t-transparent p-[1px]', className), ...props, children: _jsx(ScrollAreaPrimitive.ScrollAreaThumb, { className: cn('relative rounded-full bg-border', orientation === 'vertical' && 'flex-1') }) })));
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
export const ScrollArea = Object.assign(ScrollAreaRoot, {
    ScrollBar,
});
//# sourceMappingURL=ScrollArea.js.map